import {useQuery} from "react-query";
import api from "../api";

export const useGetDao = () => {
    return useQuery(["dao"], () => {
        return api.get("dao").then((res) => res.data);
    });
}